import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { User, Bell, Shield, Database, Zap } from 'lucide-react';
export function SettingsPage() {
  const [activeTab, setActiveTab] = useState<'profile' | 'notifications' | 'security' | 'data' | 'automations'>('profile');
  const tabs = [{
    key: 'profile',
    label: 'Profil',
    icon: User
  }, {
    key: 'notifications',
    label: 'Benachrichtigungen',
    icon: Bell
  }, {
    key: 'security',
    label: 'Sicherheit',
    icon: Shield
  }, {
    key: 'data',
    label: 'Daten & Export',
    icon: Database
  }, {
    key: 'automations',
    label: 'Automationen',
    icon: Zap
  }];
  return <div className="p-6 space-y-6" data-id="element-365">
      <div data-id="element-366">
        <h1 className="text-3xl font-bold text-foreground" data-id="element-367">Einstellungen</h1>
        <p className="text-muted-foreground mt-1" data-id="element-368">
          Systemeinstellungen und Präferenzen verwalten
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-4 gap-6" data-id="element-369">
        <div className="space-y-2" data-id="element-370">
          {tabs.map(tab => {
          const Icon = tab.icon;
          return <button key={tab.key} onClick={() => setActiveTab(tab.key as any)} className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg text-left transition-colors ${activeTab === tab.key ? 'bg-[#ededed]/30 text-foreground border border-[#f88d3e]/30' : 'text-muted-foreground hover:bg-muted'}`} data-id="element-371">
                <Icon className="h-5 w-5" data-id="element-372" />
                <span className="font-medium" data-id="element-373">{tab.label}</span>
              </button>;
        })}
        </div>

        <div className="lg:col-span-3" data-id="element-374">
          {activeTab === 'profile' && <Card data-id="element-375">
              <CardHeader data-id="element-376">
                <CardTitle data-id="element-377">Profil-Einstellungen</CardTitle>
                <CardDescription data-id="element-378">
                  Verwalten Sie Ihre persönlichen Informationen
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-379">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-380">
                  <div className="space-y-2" data-id="element-381">
                    <Label data-id="element-382">Vorname</Label>
                    <Input placeholder="Maximilian" defaultValue="Maximilian" data-id="element-383" />
                  </div>
                  <div className="space-y-2" data-id="element-384">
                    <Label data-id="element-385">Nachname</Label>
                    <Input placeholder="Saal" defaultValue="Saal" data-id="element-386" />
                  </div>
                </div>
                <div className="space-y-2" data-id="element-387">
                  <Label data-id="element-388">E-Mail</Label>
                  <Input type="email" placeholder="maximilian@mission5.de" defaultValue="maximilian@mission5.de" data-id="element-389" />
                </div>
                <div className="space-y-2" data-id="element-390">
                  <Label data-id="element-391">Telefon</Label>
                  <Input type="tel" placeholder="+49 123 456789" data-id="element-392" />
                </div>
                <div className="space-y-2" data-id="element-393">
                  <Label data-id="element-394">Unternehmen</Label>
                  <Input placeholder="Mission5" defaultValue="Mission5" data-id="element-395" />
                </div>
                <Button variant="secondary" data-id="element-396">Änderungen speichern</Button>
              </CardContent>
            </Card>}

          {activeTab === 'notifications' && <Card data-id="element-397">
              <CardHeader data-id="element-398">
                <CardTitle data-id="element-399">Benachrichtigungen</CardTitle>
                <CardDescription data-id="element-400">
                  Verwalten Sie Ihre Benachrichtigungseinstellungen
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-401">
                <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-402">
                  <div data-id="element-403">
                    <p className="font-medium text-foreground" data-id="element-404">
                      Browser Benachrichtigungen
                    </p>
                    <p className="text-sm text-muted-foreground" data-id="element-405">
                      Erhalten Sie Updates im Browser
                    </p>
                  </div>
                  <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-406" />
                </div>
                <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-407">
                  <div data-id="element-408">
                    <p className="font-medium text-foreground" data-id="element-409">
                      Follow-up Erinnerungen
                    </p>
                    <p className="text-sm text-muted-foreground" data-id="element-410">
                      Tägliche Erinnerungen für Follow-ups
                    </p>
                  </div>
                  <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-411" />
                </div>
                <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-412">
                  <div data-id="element-413">
                    <p className="font-medium text-foreground" data-id="element-414">
                      Überfällige Aufgaben
                    </p>
                    <p className="text-sm text-muted-foreground" data-id="element-415">
                      Benachrichtigung bei überfälligen Tasks
                    </p>
                  </div>
                  <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-416" />
                </div>
                <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-417">
                  <div data-id="element-418">
                    <p className="font-medium text-foreground" data-id="element-419">Neue Kontakte</p>
                    <p className="text-sm text-muted-foreground" data-id="element-420">
                      Info bei neuen Kontakten
                    </p>
                  </div>
                  <input type="checkbox" className="h-5 w-5" data-id="element-421" />
                </div>
                <Button variant="secondary" data-id="element-422">Einstellungen speichern</Button>
              </CardContent>
            </Card>}

          {activeTab === 'security' && <Card data-id="element-423">
              <CardHeader data-id="element-424">
                <CardTitle data-id="element-425">Sicherheit</CardTitle>
                <CardDescription data-id="element-426">
                  Verwalten Sie Ihre Sicherheitseinstellungen
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-427">
                <div className="space-y-2" data-id="element-428">
                  <Label data-id="element-429">Aktuelles Passwort</Label>
                  <Input type="password" placeholder="••••••••" data-id="element-430" />
                </div>
                <div className="space-y-2" data-id="element-431">
                  <Label data-id="element-432">Neues Passwort</Label>
                  <Input type="password" placeholder="••••••••" data-id="element-433" />
                </div>
                <div className="space-y-2" data-id="element-434">
                  <Label data-id="element-435">Passwort bestätigen</Label>
                  <Input type="password" placeholder="••••••••" data-id="element-436" />
                </div>
                <Button variant="secondary" data-id="element-437">Passwort ändern</Button>

                <div className="pt-6 border-t border-border" data-id="element-438">
                  <h3 className="font-medium text-foreground mb-4" data-id="element-439">
                    Zwei-Faktor-Authentifizierung
                  </h3>
                  <div className="flex items-center justify-between p-4 border border-border rounded-lg" data-id="element-440">
                    <div data-id="element-441">
                      <p className="font-medium text-foreground" data-id="element-442">
                        2FA aktivieren
                      </p>
                      <p className="text-sm text-muted-foreground" data-id="element-443">
                        Zusätzliche Sicherheitsebene
                      </p>
                    </div>
                    <Button variant="outline" size="sm" data-id="element-444">
                      Aktivieren
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>}

          {activeTab === 'data' && <Card data-id="element-445">
              <CardHeader data-id="element-446">
                <CardTitle data-id="element-447">Daten & Export</CardTitle>
                <CardDescription data-id="element-448">
                  Verwalten und exportieren Sie Ihre Daten
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-449">
                <div className="p-4 border border-border rounded-lg" data-id="element-450">
                  <h3 className="font-medium text-foreground mb-2" data-id="element-451">
                    Kontakte exportieren
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4" data-id="element-452">
                    Exportieren Sie alle Ihre Kontakte als CSV
                  </p>
                  <Button variant="outline" data-id="element-453">CSV Export</Button>
                </div>
                <div className="p-4 border border-border rounded-lg" data-id="element-454">
                  <h3 className="font-medium text-foreground mb-2" data-id="element-455">
                    KPI Daten exportieren
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4" data-id="element-456">
                    Exportieren Sie Ihre KPI-Daten
                  </p>
                  <Button variant="outline" data-id="element-457">Daten exportieren</Button>
                </div>
                <div className="p-4 border border-red-500/20 rounded-lg bg-red-500/5" data-id="element-458">
                  <h3 className="font-medium text-red-600 mb-2" data-id="element-459">
                    Daten löschen
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4" data-id="element-460">
                    Alle Ihre Daten permanent löschen
                  </p>
                  <Button variant="destructive" data-id="element-461">Alle Daten löschen</Button>
                </div>
              </CardContent>
            </Card>}

          {activeTab === 'automations' && <Card data-id="element-462">
              <CardHeader data-id="element-463">
                <CardTitle data-id="element-464">Automationen</CardTitle>
                <CardDescription data-id="element-465">
                  Automatisieren Sie Workflows innerhalb von Speedscaling CRM
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4" data-id="element-466">
                <div className="p-4 rounded-lg bg-[#ededed]/30 border border-[#f88d3e]/20 mb-4" data-id="element-467">
                  <p className="text-sm text-muted-foreground" data-id="element-468">
                    <strong data-id="element-469">Hinweis:</strong> Diese Automationen funktionieren
                    nur innerhalb von Speedscaling CRM und beeinflussen keine
                    externen Systeme.
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#ededed]/20 transition-colors" data-id="element-470">
                  <div className="flex items-center justify-between mb-2" data-id="element-471">
                    <h3 className="font-medium text-foreground" data-id="element-472">
                      Auto Follow-up nach 3 Tagen
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-473" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-474">
                    Kontakt wird automatisch in "Follow-up" verschoben, wenn 3
                    Tage keine Aktivität
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#ededed]/20 transition-colors" data-id="element-475">
                  <div className="flex items-center justify-between mb-2" data-id="element-476">
                    <h3 className="font-medium text-foreground" data-id="element-477">
                      Überfällige Aufgaben markieren
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-478" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-479">
                    Kontakte mit überschrittenem Follow-up Datum werden
                    automatisch als "Überfällig" markiert
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#ededed]/20 transition-colors" data-id="element-480">
                  <div className="flex items-center justify-between mb-2" data-id="element-481">
                    <h3 className="font-medium text-foreground" data-id="element-482">
                      Auto-Tagging nach Stage
                    </h3>
                    <input type="checkbox" className="h-5 w-5" data-id="element-483" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-484">
                    Kontakte erhalten automatisch Tags basierend auf ihrer
                    Pipeline-Stage
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#ededed]/20 transition-colors" data-id="element-485">
                  <div className="flex items-center justify-between mb-2" data-id="element-486">
                    <h3 className="font-medium text-foreground" data-id="element-487">
                      Kalender-Synchronisation
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-488" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-489">
                    Follow-up Termine werden automatisch im Kalender angezeigt
                  </p>
                </div>

                <div className="p-4 border border-border rounded-lg hover:bg-[#ededed]/20 transition-colors" data-id="element-490">
                  <div className="flex items-center justify-between mb-2" data-id="element-491">
                    <h3 className="font-medium text-foreground" data-id="element-492">
                      KPI Auto-Berechnung
                    </h3>
                    <input type="checkbox" className="h-5 w-5" defaultChecked data-id="element-493" />
                  </div>
                  <p className="text-sm text-muted-foreground" data-id="element-494">
                    KPIs werden automatisch aus Ihren Kontakt-Aktivitäten
                    berechnet
                  </p>
                </div>

                <Button variant="secondary" className="w-full" onClick={() => alert('Neue Automation erstellen - Feature in Entwicklung')} data-id="element-495">
                  <Zap className="h-4 w-4 mr-2" data-id="element-496" />
                  Neue Automation erstellen
                </Button>
              </CardContent>
            </Card>}
        </div>
      </div>
    </div>;
}